//      
export { default } from './use-hidden-text-element';



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/use-hidden-text-element/index.js